import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectItemNew,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import React, { useState } from "react";
import { useDarkTheme } from "@/contexts/DarkTheme";
import { IoFilterOutline } from "react-icons/io5";
import { IoMdArrowUp, IoMdArrowDown } from "react-icons/io";
import Image from "next/image";
const index = ({ filters, setFilters }: any) => {
  let [sortOptions, setSortOptions] = useState([
    {
      name: "Copiers",
      asc: { key: "copiers_asc", label: "asc", arrow: <IoMdArrowUp /> },
      desc: { key: "copiers_desc", label: "desc", arrow: <IoMdArrowDown /> },
    },
    {
      name: "Win %",
      asc: { key: "win_asc", label: "asc", arrow: <IoMdArrowUp /> },
      desc: { key: "win_desc", label: "desc", arrow: <IoMdArrowDown /> },
    },
    {
      name: "Drawdown",
      asc: { key: "dd_asc", label: "asc", arrow: <IoMdArrowUp /> },
      desc: { key: "dd_desc", label: "desc", arrow: <IoMdArrowDown /> },
    },
    {
      name: "Take Profit",
      asc: { key: "tp_asc", label: "asc", arrow: <IoMdArrowUp /> },
      desc: { key: "tp_desc", label: "desc", arrow: <IoMdArrowDown /> },
    },
    {
      name: "Stop Loss",
      asc: { key: "sl_asc", label: "asc", arrow: <IoMdArrowUp /> },
      desc: { key: "sl_desc", label: "desc", arrow: <IoMdArrowDown /> },
    },
  ]);
  const { darkTheme } = useDarkTheme();

  const handleChange = (key: string, value: string) => {
    setFilters((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };
  return (
    <div className="sortFilterMarketplace">
      <Select
        value={filters.sort_order}
        onValueChange={(value) => {
          if (value == "none") {
            value = "";
          }
          handleChange("sort_order", value);
        }}
      >
        <SelectTrigger className="w-[50px] outline-none cursor-pointer border-none bg-transparent text-lg ">
          <Image
            width={22}
            height={22}
            src="/images/marketplace/filter.png"
            alt="filter image"
            className={`mr-2 cursor-pointer ${
              darkTheme ? "" : "marketplace-filter-icon-dark"
            }`}
          />
        </SelectTrigger>
        <SelectContent>
          <div className="flex items-center justify-between pt-4 pl-3 pr-3 w-full">
            <div className="text-[#757575] font-bold">Sort Options</div>
            <Image
              width={15}
              height={15}
              src="/images/marketplace/filter.png"
              alt="filter image"
              className={`mr-2 ${
                darkTheme ? "" : "marketplace-filter-icon-dark"
              }`}
            />
          </div>
          <SelectGroup>
            {/* {filters.sort_order && (
              <div className="flex my-4 pl-4">
                <SelectItemNew
                  value="none"
                  className={`cursor-pointer w-[50px]  hover:text-[--marketplace-blue-new] ${
                    filters.sort_order == "" && "text-[--marketplace-blue-new]"
                  }`}
                >
                  Default
                </SelectItemNew>
              </div>
            )} */}

            {sortOptions.map((each: any, index: number) => {
              return (
                <div className="flex my-4 pl-4" key={each.name + "_" + index}>
                  <div className="text-sm w-[120px]">{each.name}</div>
                  <SelectItemNew
                    value={each.asc.key}
                    key={each.asc.key + "_" + index}
                    className={`cursor-pointer w-[50px]  hover:text-[--marketplace-blue-new] ${
                      filters.sort_order == each.asc.key &&
                      "text-[--marketplace-blue-new]"
                    }`}
                  >
                    <div className="flex text-sm justify-center items-center">
                      <div className="">{each.asc.label}</div>{" "}
                      <div>{each.asc.arrow}</div>
                    </div>
                  </SelectItemNew>
                  <SelectItemNew
                    value={each.desc.key}
                    key={each.desc.key + "_" + index}
                    className={`cursor-pointer  w-[60px] hover:text-[--marketplace-blue-new] ${
                      filters.sort_order == each.desc.key &&
                      "text-[--marketplace-blue-new]"
                    }`}
                  >
                    <div className="flex text-sm justify-center items-center">
                      <div className="">{each.desc.label}</div>{" "}
                      <div>{each.desc.arrow}</div>
                    </div>
                  </SelectItemNew>
                </div>
              );
            })}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
export default index;
